/** Стиль-пак «editorial-serif» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'editorial-serif',
  shape: {
    radiusCard: 16, radiusOption: 16, radiusButton: 'pill', radiusImage: 12,
    borderWidth: 1, borderTone: 'neutral-warm', selectionMode: 'border', shadow: 'none',
  },
  density: { optionHeight: 66, optionPadY: 16, optionPadX: 16, gap: 0, contentMaxWidth: 440, screenPadX: 20 },
  type: {
    headingFamily: 'serif', h1Size: 32, h1Weight: 400, h1Tracking: 0,
    qSize: 32, qWeight: 400, qTracking: 0, optionSize: 16, optionWeight: 400,
    headingAlign: 'center', overlineTransform: 'none',
  },
  chrome: { progress: 'none', progressLabel: 'none', counter: false, backButton: 'none', logo: 'left' },
  cta: { placement: 'none', fullWidth: true, height: 56, disabledStyle: 'grey' },
  states: { selected: 'brand-border-tint', hoverTint: true, transitionMs: 0, screenFadeMs: 0 },
  imagery: {
    optionCard: 'icon-circle', overlayTone: 'none', frame: 'circle',
    promptHint: 'flat round icon or emblem, muted editorial palette',
  },
  // Babbel: журнальный разворот читается сверху вниз, список без зазоров.
  // Картинки — плоские иконки на тёплой бумаге: затемнение убило бы бежевый.
  layout: { alignY: 'top', alignX: 'center', backgroundOverlay: 'none' },
  // Babbel-журнальность: спокойный список стадий и цитата вместо процента —
  // цифра в этой типографике выглядит инородно.
  loader: {
    style: 'all-stages', showPercent: false, socialProof: 'review',
    answersSummary: false, engagementModals: true,
  },
  // Babbel-редакционность: обратный отсчёт спорит со сдержанным тоном, поэтому
  // таймера нет, а скидка объявляется строкой-плашкой. Помесячная цена,
  // шапка-крышка над рекомендованным тарифом; длинный текстовый лендинг
  // требует повтора блока покупки внизу, но не sticky-хедера.
  paywall: {
    timer: 'none', promoTicket: 'plain', priceMode: 'per-month',
    planHighlight: 'cap-header', dimUnselectedPlans: false,
    stickyHeader: false, repeatPurchaseBlock: true,
  },
  // Бежевая редакционность: зелёный на гарантии допустим, золото было бы
  // чужеродным украшением — премиум остаётся типографским.
  accents: { money: 'success', premium: 'none' },
};
